import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Line = _resolveComponent("Line")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Line, {
      ref: "graph",
      style: {"height":"400px"},
      data: _ctx.data,
      options: _ctx.options
    }, null, 8, ["data", "options"])
  ]))
}